import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {EcorealCtSharedModule} from "../../../../shared/shared.module";
import {FormsModule} from "@angular/forms";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {TranslateDirective, TranslateService} from "@ngx-translate/core";
import {Range} from "../../../../shared/model/range-model";
import {
  AssociateOptionCategoryPayload,
  AssociateOptionPayload,
  CubicleOption,
  EditCategoryPayload
} from "../../../../shared/model/cubicleOption-model";
import {CommonModalComponent} from "../../../../shared/common-modal/common-modal.component";
import {TranslationService} from "../../../shared";
import {Category} from "../../../../configuration/shared/model/IProduct";
import {result} from "lodash";
import {OptionsService} from "../../../../shared/services/options.service";
import {MultiSelect} from "primeng/multiselect";

@Component({
  selector: 'app-odm-edit-category-assignation-modal',
  imports: [
    EcorealCtSharedModule,
    FormsModule,
    KeyValuePipe,
    NgForOf,
    NgIf,
    TranslateDirective,
    MultiSelect
  ],
  templateUrl: './odm-edit-category-assignation-modal.component.html',
  styleUrl: './odm-edit-category-assignation-modal.component.scss'
})
export class OdmEditCategoryAssignationModalComponent {
  @Input()
  selectedRange: Range;
  @Input()
  selectedCategoryId: string;

  @Output()
  saveOptionCategory: EventEmitter<AssociateOptionCategoryPayload> = new EventEmitter<AssociateOptionCategoryPayload>();

  @ViewChild('editOptionCategoryModal', {static: false}) editOptionCategoryModal: CommonModalComponent;

  languages: string[];

  editOptionCategoryForm: EditCategoryPayload = {categoryId: '', value: {}};
  availableOptions: CubicleOption[];
  selectedOptions: CubicleOption[];
  selectedOptionIds: string[] = [];
  selectedCategory: Category;
  loading: boolean = false;

  constructor(private readonly translateService: TranslateService,
              private readonly optionsService: OptionsService,
              private readonly translationService: TranslationService) {
  }

  show(rangeId: string, category: Category, selectedOptionIds: string[]){
    this.loading = true;
    this.selectedOptionIds = selectedOptionIds;
    this.selectedCategory = category;
    if(this.selectedCategory !== null && this.selectedCategory !== undefined) {
      this.translationService.getLocalesOfCountryOfKey(category.name).subscribe((locale => {
        locale.forEach(loc => {
          this.editOptionCategoryForm.value[loc.language] = loc.translations[0].translation;
        })
      }));
    } else {
      this.editOptionCategoryForm.value = {};
    }
    this.optionsService.getOptionsElementsByRangeId(rangeId).subscribe(result => {
      this.availableOptions = result
        .filter(opt => opt && opt.name && opt.name.trim().length > 0)
        .filter(opt => this.isValidOption(opt));
      this.availableOptions.forEach(option => {
        option.name = this.translateService.instant(option.name);
      });
      this.availableOptions = this.availableOptions.toSorted((a, b) => a.name.localeCompare(b.name));
      this.selectedOptions = result.filter(option => this.selectedOptionIds.includes(option.id));
      this.loading = false;
    })
    this.editOptionCategoryModal.show();
  }


  hide() {
    this.editOptionCategoryModal.hide();
  }

  isValidForm(): boolean {
    for (let key in this.editOptionCategoryForm.value) {
      if(!this.editOptionCategoryForm.value[key]){
        return false;
      }
    }
    return true;
  }


  clickOnSaveOption() {
    const editPayload: AssociateOptionCategoryPayload = {
      options: this.selectedOptions,
      component: '',
      rangeId: this.selectedRange.id,
      categoryId: this.selectedCategory === null ||this.selectedCategory === undefined ? null : this.selectedCategory.id
    };
    this.saveOptionCategory.emit(editPayload);
  }

  private isValidOption(opt: CubicleOption): boolean {
    const values = (opt.values ? opt.values : []).filter(value => value && value.value && value.value.trim().length > 0);
    const hasReference = values.some(value => value.reference && value.reference.ref && value.reference.ref.trim().length > 0);
    const hasOnlyWithoutValue = values.length === 1 && values[0] && values[0].value === 'T_WITHOUT';

    if (values.length === 0 || hasOnlyWithoutValue || !hasReference) {
      return false;
    }

    return !opt.mandatory || values.length >= 2;
  }

  // function for the ngfor + ngmodel, so it doesn't lose focus
  trackByFn(index, item): number {   return index; }

}
